document.addEventListener('DOMContentLoaded', function() {

    // --- HOMEPAGE LOGO LINK BEHAVIOR ---
    // Prevent page reload when clicking logo on homepage
    const logoLink = document.querySelector('.navbar_logo-link');
    if (logoLink) {
        const currentPath = window.location.pathname;
        const isHomepage = currentPath === '/' || currentPath.endsWith('/index.html') || currentPath.endsWith('/');
        if (isHomepage) {
            logoLink.addEventListener('click', (e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }
    }

    // --- DESKTOP DROPDOWN NAVIGATION ---
    const dropdownToggles = document.querySelectorAll('.navbar_dropdown-toggle');

    dropdownToggles.forEach(toggle => {
        const dropdown = toggle.closest('.navbar_dropdown');

        // Click handler for toggle
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            dropdown.classList.toggle('is-open');

            // Update ARIA attributes
            const isExpanded = dropdown.classList.contains('is-open');
            toggle.setAttribute('aria-expanded', isExpanded);
        });

        // Keyboard navigation support: Escape closes from the toggle or from any item in the menu
        dropdown.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
                dropdown.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
                toggle.focus();
            }
        });

        // Tabbing out of the menu closes it, so an open panel never sits over the page
        dropdown.addEventListener('focusout', (e) => {
            if (!dropdown.contains(e.relatedTarget)) {
                dropdown.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });
    });

    // Single delegated listener to close dropdowns when clicking outside (performance optimization)
    document.addEventListener('click', (e) => {
        document.querySelectorAll('.navbar_dropdown.is-open').forEach(dropdown => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove('is-open');
                const toggle = dropdown.querySelector('.navbar_dropdown-toggle');
                if (toggle) {
                    toggle.setAttribute('aria-expanded', 'false');
                }
            }
        });
    });

    // --- MOBILE DROPDOWN NAVIGATION (single-open accordion inside the drawer) ---
    const mobileDropdownToggles = document.querySelectorAll('.mobile-nav_dropdown-toggle');

    mobileDropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const dropdown = this.closest('.mobile-nav_dropdown');
            const isOpen = dropdown.classList.contains('is-open');

            // Close all other mobile dropdowns
            document.querySelectorAll('.mobile-nav_dropdown').forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    otherDropdown.classList.remove('is-open');
                    const otherToggle = otherDropdown.querySelector('.mobile-nav_dropdown-toggle');
                    otherToggle.setAttribute('aria-expanded', 'false');
                }
            });

            // Toggle current dropdown
            dropdown.classList.toggle('is-open');
            this.setAttribute('aria-expanded', !isOpen);
        });
    });

    // --- MOBILE NAVIGATION DRAWER ---
    // Slide-in panel + dimmed backdrop. Opened by the hamburger; closed by the
    // in-drawer ✕, the backdrop, Escape, or following a link. Manages focus trap,
    // focus-return, ARIA, and body-scroll-lock. Desktop nav handlers are untouched.
    const hamburgerButton = document.getElementById('hamburger-button');
    const mobileNav = document.getElementById('mobile-nav');
    const mobileNavBackdrop = document.getElementById('mobile-nav-backdrop');
    const mobileNavClose = document.getElementById('mobile-nav-close');

    if (hamburgerButton && mobileNav) {
        const FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';

        // Focusable elements currently reachable (excludes collapsed dropdown children)
        function getFocusable() {
            return Array.from(mobileNav.querySelectorAll(FOCUSABLE)).filter(el => {
                const submenu = el.closest('.mobile-nav_dropdown-menu');
                if (submenu && !submenu.closest('.mobile-nav_dropdown').classList.contains('is-open')) {
                    return false;
                }
                return true;
            });
        }

        function onKeydown(e) {
            if (e.key === 'Escape') {
                closeMobileNav();
                return;
            }
            if (e.key === 'Tab') {
                const focusables = getFocusable();
                if (focusables.length === 0) return;
                const first = focusables[0];
                const last = focusables[focusables.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

        function openMobileNav() {
            mobileNav.classList.add('is-open');
            hamburgerButton.classList.add('is-active');
            hamburgerButton.setAttribute('aria-expanded', 'true');
            hamburgerButton.setAttribute('aria-label', 'Close Menu');
            mobileNav.setAttribute('aria-hidden', 'false');
            if (mobileNavBackdrop) mobileNavBackdrop.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            document.body.classList.add('mobile-nav-open');
            document.addEventListener('keydown', onKeydown);
            // Move focus into the drawer
            (mobileNavClose || getFocusable()[0])?.focus();
        }

        function closeMobileNav(returnFocus = true) {
            mobileNav.classList.remove('is-open');
            hamburgerButton.classList.remove('is-active');
            hamburgerButton.setAttribute('aria-expanded', 'false');
            hamburgerButton.setAttribute('aria-label', 'Open Menu');
            mobileNav.setAttribute('aria-hidden', 'true');
            if (mobileNavBackdrop) mobileNavBackdrop.classList.remove('is-open');
            document.body.style.overflow = '';
            document.body.classList.remove('mobile-nav-open');
            document.removeEventListener('keydown', onKeydown);
            // Collapse any open dropdowns
            mobileNav.querySelectorAll('.mobile-nav_dropdown.is-open').forEach(dropdown => {
                dropdown.classList.remove('is-open');
                dropdown.querySelector('.mobile-nav_dropdown-toggle').setAttribute('aria-expanded', 'false');
            });
            if (returnFocus) hamburgerButton.focus();
        }

        hamburgerButton.addEventListener('click', function() {
            if (mobileNav.classList.contains('is-open')) {
                closeMobileNav();
            } else {
                openMobileNav();
            }
        });

        if (mobileNavClose) mobileNavClose.addEventListener('click', () => closeMobileNav());
        if (mobileNavBackdrop) mobileNavBackdrop.addEventListener('click', () => closeMobileNav());

        // Following any nav link closes the drawer (no focus-return; the page navigates)
        mobileNav.querySelectorAll('a[href]').forEach(link => {
            link.addEventListener('click', () => closeMobileNav(false));
        });
    }

    // --- FAQ / DISCLOSURE: single-open progressive enhancement ---
    // Native <details class="faq-item-expandable"> already work with no JS (each opens and
    // closes on its own; content is never hidden by script). This only ADDS a one-at-a-time
    // "close others" feel: when one item in a group opens, sibling items in the same group
    // close. Groups are siblings under a shared parent (e.g. each .faq-accordion), so separate
    // accordions and standalone .expandable-section major sections are unaffected.
    document.querySelectorAll('details.faq-item-expandable').forEach(item => {
        item.addEventListener('toggle', () => {
            if (!item.open || !item.parentElement) return;
            item.parentElement
                .querySelectorAll(':scope > details.faq-item-expandable')
                .forEach(other => {
                    if (other !== item && other.open) {
                        other.open = false;
                    }
                });
        });
    });

    // --- FADE-UP ON SCROLL ANIMATION ---
    const elementsToAnimate = document.querySelectorAll('.fade-up-on-scroll');

    // Check if IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1 // Trigger when 10% of the element is visible
        });

        elementsToAnimate.forEach(element => {
            observer.observe(element);
        });
    } else {
        // Fallback for older browsers: just show the elements
        elementsToAnimate.forEach(element => {
            element.classList.add('is-visible');
        });
    }

    // --- TABS FOR RESOURCES PAGE ---
    const tabButtons = document.querySelectorAll('.tab_button');
    const tabContents = document.querySelectorAll('.tab_content');

    if (tabButtons.length > 0 && tabContents.length > 0) {
        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                const targetId = button.getAttribute('data-tab');

                // Update buttons
                tabButtons.forEach(btn => btn.classList.remove('is-active'));
                button.classList.add('is-active');

                // Update content
                tabContents.forEach(content => {
                    if (content.id === targetId) {
                        content.classList.add('is-active');
                    } else {
                        content.classList.remove('is-active');
                    }
                });
            });
        });
    }

    // --- MOBILE STICKY CTA BUTTON ---
    const mobileCTA = document.getElementById('mobile-cta-sticky');

    if (mobileCTA) {
        let isVisible = false;
        const showThreshold = 300; // Show after scrolling 300px past hero

        function isMobileDevice() {
            return window.innerWidth <= 768;
        }

        function handleScroll() {
            // Only run on mobile devices
            if (!isMobileDevice()) {
                // Ensure button is hidden on desktop
                if (isVisible) {
                    mobileCTA.classList.remove('is-visible');
                    mobileCTA.setAttribute('aria-hidden', 'true');
                    isVisible = false;
                }
                return;
            }

            const scrollY = window.scrollY;
            const shouldShow = scrollY > showThreshold;

            if (shouldShow && !isVisible) {
                // Show the button using CSS transform+visibility (no CLS)
                mobileCTA.classList.add('is-visible');
                mobileCTA.setAttribute('aria-hidden', 'false');
                isVisible = true;
            } else if (!shouldShow && isVisible) {
                // Hide the button using CSS transform+visibility (no CLS)
                mobileCTA.classList.remove('is-visible');
                mobileCTA.setAttribute('aria-hidden', 'true');
                isVisible = false;
            }
        }

        // Throttle scroll events for better performance
        let scrollTimeout;
        window.addEventListener('scroll', () => {
            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }
            scrollTimeout = setTimeout(handleScroll, 10);
        });

        // Handle window resize to hide/show based on screen size
        window.addEventListener('resize', () => {
            handleScroll();
        });

        // Initial check
        handleScroll();
    }

    // --- SCROLL TO SECTION FUNCTIONALITY ---
    // Used on your-rights.html and other pages with section navigation
    document.querySelectorAll('.scroll-to-section').forEach(button => {
        button.addEventListener('click', function() {
            const targetId = this.dataset.targetId;
            const element = document.getElementById(targetId);
            if (element) {
                element.classList.add('active');
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });

    // --- OPEN <details> ACCORDION WHEN TARGETED BY A JUMP LINK / DEEP LINK ---
    // Lets "On this page" links (and shared #hash URLs) expand a collapsed section.
    function openTargetedDetails() {
        if (window.location.hash.length > 1) {
            const target = document.getElementById(window.location.hash.slice(1));
            if (target && target.tagName === 'DETAILS' && !target.open) {
                target.open = true;
            }
        }
    }
    openTargetedDetails();
    window.addEventListener('hashchange', openTargetedDetails);

    // --- WIDE TABLE "MORE COLUMNS" CUE ---
    // .has-more fades the right edge of a .table-responsive while columns are still hidden
    // there (style-core.css); it drops once the table is scrolled to its end or fits.
    document.querySelectorAll('.table-responsive').forEach(box => {
        const update = () => {
            box.classList.toggle('has-more', box.scrollLeft + box.clientWidth < box.scrollWidth - 2);
        };
        box.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    });

});
